<template>
   <div class="gallery p-0">
      <div class="row">
         <div class="col-12">
            <div
               v-for="(product, i) in gallery"
               :key="`${product.description}-${i}`"
               class="gallery-product"
            >
               <div class="gallery-product-header">
                  <h2 :id="product.slug" :ref="product.slug" class="h2">{{ product.title }}</h2>
               </div>
               <div
                  class="description-container mt-1 pr-0 pr-xl-4"
                  v-html="markedRender(product.description)"
               />
               <div :class="['card-deck', 'card-deck-special mb-4']">
                  <div
                     v-for="(cardItem, ii) in product.items"
                     v-if="galleryType === ''"
                     :key="ii"
                     class="card"
                  >
                     <a
                        :href="cardItem.onclick"
                        class="card-content"
                        @click.prevent="goto(cardItem.onclick)"
                     >
                        <div class="item-container">
                           <div class="item-container-box">
                              <img
                                 v-lazy-image
                                 :data-src="cardItem.image"
                                 src="/public/images/white-placeholder.svg"
                                 alt="FusionCharts Chart Gallery - Line Column Bar Pie"
                                 class="item-container-box-img"
                                 style="padding-bottom: 0 !important"
                              />
                           </div>
                           <div class="card-body pb-2" style="padding-top: 15px">
                              <h3 class="card-title bold mb-1">{{ cardItem.title }}</h3>
                              <p class="card-text">{{ cardItem.subtitle }}</p>
                           </div>
                        </div>
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
// import { setTimeout } from 'timers';

export default {
   name: 'ChartGalleryOverview',
   props: {
      gallery: {
         type: Array,
         default: () => [],
      },
      galleryType: {
         type: String,
         default: '',
      },
      shortdesc: {
         type: String,
         default: null,
      },
   },

   created() {
      // check if there is any query framework
      // this.queryProduct = this.$route.query.product;
   },

   mounted() {
      // const header = this.$refs[this.queryProduct];
      // this.$nextTick(() => {
      //    if (header) {
      //       const currentPos = document.documentElement.scrollTop;
      //       const goingTo = header[0].offsetTop;
      //       const travelTime =
      //          Math.abs(currentPos - goingTo) > 1200
      //             ? 1000
      //             : (Math.abs(currentPos - goingTo) * 1000) / 1200;
      //       fusionDesign.scroll.to(goingTo, Math.round(travelTime), 'easeInOutExpo');
      //    }
      // });
   },

   methods: {
      goto(link) {
         this.$router.push(link).catch(() => {});
      },
   },
};
</script>

<style lang="scss" scoped>
@import '../../util';
@import '../../common_scss/img.scss';

.shortdesc {
   color: #73748c;
}

.grouped {
   display: inline-flex !important;
   border-radius: 4px;
   overflow: hidden;
   box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
   flex-wrap: nowrap;

   .nav-link {
      background: #ffffff;
      color: #686980;
      font-size: 16px;
      transition: all ease 0.4s;
      margin-right: 1px;

      &:hover {
         color: #6957da;
      }
   }
   .nav-link:last-child(1) {
      margin-right: 0;
   }
   .nav-link.active {
      box-shadow: none;
      background: #6957da;
      color: #ffffff;
   }
   .nac-item {
      padding: 13px 24px;
   }

   &.nav-pills {
      margin-bottom: 11px !important;
   }
}
.gallery {
   .gallery-selector {
      margin: 0 auto 15px auto;
      max-width: 300px;
      width: 100%;
   }

   .card-selector {
      margin-left: 0;
      margin-right: 0;

      // @include media-breakpoint-up(md) {
      //    margin-right: 25px;
      // }

      &-wrapper {
         display: flex;

         .nav {
            margin: 0 auto 15px auto;
         }
      }
   }

   .card {
      margin: 25px 25px 0 0;
      transition: all ease 0.35s;

      .card-anchor {
         text-decoration: none;
         img {
            width: 100%;
         }
      }
   }

   .slick {
      h2 {
         font-size: 16px;
         font-weight: 600;
         line-height: 20px;
         letter-spacing: 0.3px;
         // padding: 10px;
         padding-left: 0;
      }
   }
   .nav-link {
      border: none;
      border-radius: 0;
   }
   .card-header-tabs {
      justify-content: center;
   }
   .bg-primary {
      background: #6957da !important;
   }
   .card-body {
      h2 {
         margin-bottom: 1rem;
      }
   }

   .column-group {
      column-gap: 2.5rem;
   }

   .card-deck-special {
      margin: 15px -15px;

      .card {
         background: none;
         border-radius: 0;
         margin: 0;
         padding: 10px 15px 20px;
         flex: 0 0 auto;
         min-width: 100%;
         max-width: 100%;

         @media (min-width: 567px) {
            flex: 0 0 auto;
            min-width: 50%;
            max-width: 50%;
         }

         @media (min-width: 1200px) {
            flex: 0 0 auto;
            min-width: 33.33%;
            max-width: 33.33%;
         }

         .card-text {
            color: #686980;
            font-size: 16px;
            letter-spacing: 0.23px;
            line-height: 24px;
         }

         .card-title {
            font-size: 16px;
            letter-spacing: 0.23px;
            line-height: 20px;
            color: #212344;
         }

         .card-content {
            height: 100%;
            background: #fff;
            border-radius: 5px;
            box-shadow: 0 6px 14px 0 rgba(33, 35, 68, 0.05) !important;

            &.explore-maps-content {
               width: auto;
               transition: all 0.2s ease;
               text-decoration: none;
               &:hover {
                  transform: translateY(-4px);
                  transition: all 0.2s ease;
               }
            }
            .explore-maps {
               height: 100%;
               width: auto;
            }
         }

         a.card-content {
            transition: all 0.2s ease;
            text-decoration: none;
            &:hover {
               transform: translateY(-4px);
               transition: all 0.2s ease;
            }
         }

         .card-img-top {
            height: 200px;
         }

         &.slick {
            .card-header {
               padding: 0;
               height: 100%;
            }
            a {
               display: block;
               padding: 15px 15px 15px 5px;
               h2 {
                  margin: 0;
               }
            }
            .img-container {
               img {
                  height: 55px;
               }
            }
         }
      }
   }
}

.explore-maps {
   background-image: url('/public/images/small-map.svg');
   background-size: contain;
   background-repeat: no-repeat;
   background-position: center;
   .text-center {
      width: 100%;
   }
}
</style>
